import { useScrollAnimation } from '../../../hooks/useScrollAnimation';
import { Link } from 'react-router-dom';

export default function AdditionalServicesSection() {
  const { ref, visible } = useScrollAnimation();

  return (
    <section className="bg-white py-20 lg:py-32">
      <div
        ref={ref}
        className={`max-w-7xl mx-auto px-6 sm:px-8 lg:px-16 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center transition-all duration-700 ease-out ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
      >
        {/* Content */}
        <div className="flex flex-col gap-5 order-2 lg:order-1">
          <div className="flex items-center gap-3">
            <div className="w-8 h-0.5 bg-primary"></div>
            <span className="text-primary text-xs font-bold uppercase tracking-[0.3em]">Additional Services</span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black uppercase text-gray-900 leading-tight" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>
            General Contracting, Windows, Siding &amp; More
          </h2>
          <p className="text-gray-600 text-sm leading-relaxed">
            We offer a full range of services including general contracting, window installation, bathroom and kitchen remodels, siding installation, concrete work, and fire restoration. Our expert team handles every detail with precision.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed">
            Whether you&apos;re repairing after fire damage or upgrading for comfort and style, we&apos;re your trusted partner for residential construction and renovation across Southwest Michigan.
          </p>

          <div className="grid grid-cols-2 gap-3 mt-2">
            {['General Contracting', 'Window Installation', 'Siding Installation', 'Kitchen Remodels', 'Bathroom Remodels', 'Fire Restoration'].map((item) => (
              <div key={item} className="flex items-center gap-2 group">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-checkbox-circle-fill text-primary text-base group-hover:text-primary-mid transition-colors duration-200"></i>
                </div>
                <span className="text-gray-700 text-sm">{item}</span>
              </div>
            ))}
          </div>

          <Link
            to="/services/general-contracting"
            className="inline-flex items-center gap-2 bg-primary hover:bg-primary-dark text-white text-xs font-bold uppercase tracking-widest px-7 py-4 rounded-md transition-all duration-200 cursor-pointer whitespace-nowrap w-fit mt-2 btn-press group"
          >
            Explore All Services
            <i className="ri-arrow-right-line transition-transform duration-200 group-hover:translate-x-1"></i>
          </Link>
        </div>

        {/* Images */}
        <div className="relative h-[440px] sm:h-[520px] lg:h-[560px] w-full order-1 lg:order-2">
          <div className="absolute top-0 right-0 w-[72%] h-[82%] overflow-hidden rounded-lg img-zoom">
            <img
              src="https://downsconstructionllc.com/images/featuredimg2-850w.jpeg"
              alt="residential construction project"
              className="w-full h-full object-cover object-top"
              loading="lazy"
              decoding="async"
            />
          </div>
          <div className="absolute bottom-0 left-0 w-[54%] h-[56%] overflow-hidden rounded-lg border-4 border-white img-zoom">
            <img
              src="https://downsconstructionllc.com/images/featuredimg1-850w.jpeg"
              alt="kitchen remodel"
              className="w-full h-full object-cover object-top"
              loading="lazy"
              decoding="async"
            />
          </div>
          <div className="absolute top-4 right-4 w-[72%] h-[82%] border-2 border-primary/20 rounded-lg -z-10"></div>
        </div>
      </div>
    </section>
  );
}
